
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

Swiper.use([Navigation, Pagination, Autoplay])

export const HotelCarouselSlider = () => {
  // const $sliderWrapper = $('.js-heroSlider__imageSliderWrapper');
  // if ( !$sliderWrapper.length ) {
  //   return
  // }

  $(document).ready(function() {
    new Swiper('.js-hotel-carousel', {
      effect: 'slide',
      autoplay: {
        delay: 4000,
      },
      speed: 600,
      pagination: {
        el: '.c-hotel-carousel__pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            `<span class="c-heroSlider__paginationItem ${className}">
              <span></span>
              <span>${index + 1}</span>
            </span>`
          )
        },
      },
      navigation: {
        nextEl: '.c-hotel-carousel__nextSlide',
        prevEl: '.c-hotel-carousel__prevSlide',
      },
    });
  });
}
